module.exports = __webpack_public_path__ + "img/null.39742106.svg";